import { learnLessons } from './learnLessons';

// The authored record is stored once. Structured fields are derived for renderers,
// review tools and assertions; no separate course copy or per-business variant.
export function resolveLearnLesson(slug: string) {
  const record = learnLessons[slug];
  if (!record) return undefined;
  const sections = record.markdown.split(/^## /m).map((value,index) => {
    const split = value.indexOf('\n');
    return { title: index ? value.slice(0,split) : '', body: index ? value.slice(split+1).trim() : value.replace(/^# .+\n/,'').trim() };
  });
  const body = (title: string) => sections.find(section=>section.title===title)?.body ?? '';
  const list = (title: string) => [...body(title).matchAll(/^- (.+)$/gm)].map(match=>match[1]);
  const procedure = body('Follow these steps');
  const numberedSteps = procedure.split(/^### (?=\d+\. )/m).filter(Boolean).map((text,index) => {
    const match=text.match(/^(\d+)\. ([^\n]+)\n([\s\S]*)/);
    const content=match?.[3] ?? text;
    const [input, expectedResponse] = content.split(/\*\*(?:Check the result|Result to check):\*\*/);
    return { order: Number(match?.[1] ?? index+1), action: match?.[2] ?? 'Follow the numbered assessment procedure', input: input.trim(), expectedResponse: expectedResponse?.trim() ?? 'Check the saved state and boundary described in this procedure.' };
  });
  const tableSteps = [...procedure.matchAll(/^\| (\d+)\. ([^|]+)\|([^|]+)\|([^|]+)\|$/gm)].map(match => ({order:Number(match[1]),action:match[2].trim(),input:match[3].trim(),expectedResponse:match[4].trim()}));
  const steps = tableSteps.length ? tableSteps : numberedSteps;
  return { ...record, sections, objectives:list('At the end of this lesson'), prerequisites:body('Before you begin'), keyIdeas:body('Key ideas'), steps, paperActivity:body('Practise'), question:body('Check your understanding').split('<details>')[0].trim(), answer:body('Check your understanding').split('</summary>')[1]?.split('</details>')[0].trim(), completionChecks:list('Check your work') };
}
